// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"css/main-bs4.min","4900":"css/rin-nd-styles"}[chunkId] + ".4.102.5.css";
};